export enum QueryKeys {
  LOGS_TAB = 'logsTab',
}

// * Shared animation props for headlessui Transition dropdowns (fade + scale).
// * TODO: replace this constant with a DropdownTransition wrapper component and
// * migrate all existing dropdown usages to it so the styles are fully encapsulated.
export const DROPDOWN_TRANSITION_PROPS = {
  enter: 'transition ease-out duration-100',
  enterFrom: 'transform opacity-0 scale-95',
  enterTo: 'transform opacity-100 scale-100',
  leave: 'transition ease-in duration-75',
  leaveFrom: 'transform opacity-100 scale-100',
  leaveTo: 'transform opacity-0 scale-95',
} as const;
